import { update } from 'autosize';
import { listConstants } from '../constants';
import { sortByField } from '../utils/sortByField';

const initialState = { loading: false, lists: [], error: '' };

export function list(state = initialState, action) {
  switch (action.type) {
    case listConstants.LIST_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    
    case listConstants.LIST_CREATED: {
      const newArray = [...state.lists.filter((item) => item.id !== action.payload.data.data.id)];

      return {
        ...state,
        lists: sortByField([...newArray, action.payload.data.data], 'position', 'asc')
      };
    }

    case listConstants.LIST_UPDATED: {
      const updatedItem = action.payload.data.data;
      const newArray = state.lists.map(item =>
        item.id === updatedItem.id ? updatedItem : item
      );

      // If the updated item was not found, add it
      const exists = state.lists.some(item => item.id === updatedItem.id);
      const finalArray = exists ? newArray : [...newArray, updatedItem];

      return {
        ...state,
        loading: false,
        lists: sortByField(finalArray, 'position', 'asc')
      };
    }

    case listConstants.LIST_DELETED: {
      const deletedItem = action.payload.data.data;
      const newArray = state.lists.filter((list) => list.id !== deletedItem.id)

      return {
        ...state,
        lists: sortByField(newArray, 'position', 'asc')
      };
    }

    case listConstants.LIST_SET: {
      return {
        ...state,
        loading: false,
        lists: action.payload.data.data.lists,
      };
    }

    case listConstants.LIST_SORT: {
      const sortedListIds = action.payload.data.data.sorted_list_ids;
      
      const newArray = state.lists.map((list) => {
        const sortedListIndex = sortedListIds.findIndex((list_id) => list_id === list.id);
        return { ...list, position: sortedListIndex !== -1 ? sortedListIndex : list.position };
      }); 

      return {
        ...state,
        loading: false,
        lists: sortByField(newArray, 'position', 'asc')
      };
    }

    // TODO: Fix this action to handle the sorting of list items
    case listConstants.LIST_ITEM_SORT: {
      const sortedListItemIds = action.payload.data.data.sorted_list_item_ids;
      const listId = action.payload.data.data.list_id;
      const list = state.lists.find(l => l.id === parseInt(listId));

      if (list) {
        const newItems = list.items.map((list_item) => {
          const sortedListIndex = sortedListItemIds.findIndex((item_id) => item_id === list_item.id);
          return { ...list_item, position: sortedListIndex !== -1 ? sortedListIndex : list_item.position };
        });
        
        const updatedList = { ...list, items: sortByField(newItems, 'position', 'asc') };

        const listsWithUpdatedItems = state.lists.map(list =>
          list.id === listId ? updatedList : list
        );

        return {
          ...state,
          loading: false,
          lists: sortByField(listsWithUpdatedItems, 'position', 'asc')
        }
      } else {
        return {
          ...state,
          loading: false
        }
      } 
    }

    case listConstants.LIST_GET: {
      return {
        ...state,
        loading: false,
        lists: action.payload.data.data.lists,
        can_create: action.payload.data.data.can_create_list,
        can_update: action.payload.data.data.can_update_list,
        can_show: action.payload.data.data.can_view_all_list,
        can_destroy: action.payload.data.data.can_destroy_list
      };
    }

    case listConstants.LIST_ITEM_CREATED: {
      const createdListItem = action.payload.data.data;

      const newArray = state.lists.map(list => {
        if(list.id === createdListItem.list_id){
          return {
            ...list,
            items: sortByField([...list.items.filter((item) => item.id !== createdListItem.id), createdListItem], 'position', 'asc')
          }
        }

        return list
      })

      return {
        ...state,
        loading: false,
        lists: sortByField(newArray, 'position', 'asc')
      };
    }

    case listConstants.LIST_ITEM_UPDATED: {
      const updatedListItem = action.payload.data.data;

      const newArray = state.lists.map(list => {
        if(list.id === updatedListItem.list_id){
          return {
            ...list,
            items: sortByField([...list.items.filter((item) => item.id !== updatedListItem.id), updatedListItem], 'position', 'asc')
          }
        }

        return list
      })

      return {
        ...state,
        loading: false,
        lists: sortByField(newArray, 'position', 'asc')
      };
    }

    case listConstants.LIST_ITEM_DELETED: {
      const deletedListItem = action.payload.data.data;
      
      const newArray = state.lists.map(list => {
        if(list.id === deletedListItem.list_id){
          return {
            ...list,
            items: sortByField([...list.items.filter((item) => item.id !== deletedListItem.id)], 'position', 'asc')
          }
        }

        return list
      })

      return {
        ...state,
        loading: false,
        lists: sortByField(newArray, 'position', 'asc')
      };
    }

    case listConstants.LIST_CLEAR: {
      return { ...initialState };
    }
  default:
    return state
  }
}
